



























import { Component, Vue, Prop } from "vue-property-decorator";
import axios from "axios";
import { JobItem } from "../../common/interfaces";
import moment from "moment";
import store from "@/store/store";

@Component({})
export default class JobListItem extends Vue {
  @Prop()
  protected job: JobItem;

  get fullDescription() {
    return `(${this.job.JobId}) ${this.job.TypeDescription}`;
  }

  get jobDisplayColor() {
    if (!this.job.ContactId) {
      return { "job-type-yellow": true };
    } else {
      switch (this.job.JobType) {
        case "SERVIC":
          return { "job-type-green": true };
        case "INSPEC":
          return { "job-type-blue": true };
        default:
          return { "job-type-red": true };
      }
    }
  }

  get overlayStyle() {
    if (this.isSelectedItem()) {
      return { "job-selected": true };
    }
  }

  protected isSelectedItem() {
    return store.state.Job.JobId === this.job.JobId;
  }

  get displayBookingDate() {
    return this.job.BookedInDateTime && this.job.BookedInDateTime.isValid()
      ? this.job.BookedInDateTime.format("DD-MM-YYYY")
      : "Not Booked In";
  }

  get displayDueDate() {
    return this.job.DueDate && this.job.DueDate.isValid()
      ? this.job.DueDate.format("DD-MM-YYYY")
      : "No Due Date";
  }

  protected selectJob() {
    const path = `/Job/${this.job.JobId}`;
    if (this.$route.path !== path) {
      this.$router.push(path);
    }
  }
}
